const FacebookRoundedIcon = ({ className, ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M12 3C16.9706 3 21 7.02944 21 12C21 16.3571 17.9036 19.9896 13.7914 20.8202V14.1477H15.6475C15.768 14.1476 15.8693 14.0573 15.8832 13.9376L16.1652 11.491C16.173 11.4237 16.1511 11.3562 16.1061 11.3057C16.0611 11.2552 15.9971 11.2259 15.9295 11.2258H13.7914V9.69247C13.7914 9.2302 14.0404 8.99581 14.5312 8.99574H15.9295C16.0606 8.99554 16.1668 8.88868 16.1668 8.75764V6.51163C16.1666 6.38072 16.0604 6.27452 15.9295 6.27433H14.0031C13.9895 6.27366 13.9589 6.27273 13.9144 6.27273C13.5798 6.27277 12.4188 6.33886 11.5014 7.18279C10.4854 8.11762 10.6254 9.23657 10.6593 9.432V11.2258H8.96458C8.83359 11.2259 8.72747 11.3321 8.72727 11.4631V13.8793C8.72747 14.0102 8.83359 14.1164 8.96458 14.1166H10.5794V20.8865C6.28396 20.2053 3 16.4871 3 12C3 7.02944 7.02944 3 12 3Z"
                fill="currentColor"
            />
        </svg>
    )
}

export default FacebookRoundedIcon